import { useTranslation } from 'react-i18next';
import {
  REPORT_DATE_RANGE_OPTIONS,
  ReportDateRangeOption,
} from '@/hooks/useReportDateRange';
import { dateRangeLabelKey } from '@/utils/dateRangeI18n';

interface ReportDateRangeButtonsProps {
  dateRange: ReportDateRangeOption;
  onDateRangeChange: (value: ReportDateRangeOption) => void;
  customFrom: string;
  customTo: string;
  onCustomFromChange: (value: string) => void;
  onCustomToChange: (value: string) => void;
}

export default function ReportDateRangeButtons({
  dateRange,
  onDateRangeChange,
  customFrom,
  customTo,
  onCustomFromChange,
  onCustomToChange,
}: ReportDateRangeButtonsProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="flex gap-2 flex-wrap">
        {REPORT_DATE_RANGE_OPTIONS.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onDateRangeChange(opt)}
            className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
              dateRange === opt
                ? 'bg-primary-600 text-white'
                : 'bg-white text-gray-600 hover:bg-gray-50 border border-gray-200'
            }`}
          >
            {t(dateRangeLabelKey(opt))}
          </button>
        ))}
      </div>

      {dateRange === 'Custom Date' && (
        <div className="flex flex-wrap gap-4 items-end pt-1 border-t border-gray-100">
          <div className="space-y-1.5 min-w-[160px]">
            <label className="text-sm font-medium text-gray-700">{t('dates.fromDate')}</label>
            <input
              type="date"
              className="input-field"
              value={customFrom}
              onChange={(e) => onCustomFromChange(e.target.value)}
            />
          </div>
          <div className="space-y-1.5 min-w-[160px]">
            <label className="text-sm font-medium text-gray-700">{t('dates.toDate')}</label>
            <input
              type="date"
              className="input-field"
              value={customTo}
              onChange={(e) => onCustomToChange(e.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  );
}
